import { CAMPAIGN_SUPPORTED_PLATFORMS } from '@/entities/campaign';
import { getPlatformLogo } from '@/entities/public-filter';

export const SupportedPlatformBadge = () => {
  return (
    <div className="bg-muted flex items-center gap-2 rounded-full px-3 py-1">
      <span className="text-muted-foreground text-xs font-medium">Available on</span>
      {CAMPAIGN_SUPPORTED_PLATFORMS.map((p) => {
        const Logo = getPlatformLogo(p);
        return <Logo className="size-3.5" />;
      })}
    </div>
  );
};
